<fieldset [disabled]="disableAfterReview">
<div class="row mt-4" style="margin-right:2px !important">
    <div class="col-md-6">
        <label for="platform" class="text-left">
            UPLOAD IMAGES <span style="text-transform: none;">(Maximum 5 Images are allowed)</span>
        </label>
    </div>
    <div class="col-md-6">
        <div class="upload-btn-wrapper d-block text-end" [ngClass]="{'disableLink': disableAfterReview}">
            <a id="btnSubmit" class="button mt-2" style="text-decoration: underline;">
                Click here to select images</a>
            <!-- <button  id="btnSubmit" class="button uploadBtnforimages mt-2">
                <img src="assets/images/download_trm.png" class="buttonIcon btnupl me-2">
                <span>CLICK HERE TO SELECT AN IMAGE FILE</span>
            </button> -->
            <input multiple accept="image/png, image/jpeg" type="file" name="myfile" type="file" [disabled]="disableAfterReview" 
             (change)="multiFileEvent($event)">
        </div>
    </div>
    <div class="col-md-12 pr-0">  
        <div class="row border mt-3 py-3 uplimgdiv" id="imageDisplayDiv">
            <ul class="ul-alignment">
                <li *ngFor="let item of salesplanImages.imageFiles;let itemIndex=index">
                    <p>
                        <a (click)="delItem(item)">
                            <i class="fas fa-window-close mr-1 redcross crossposition-imageupload"></i>
                        </a>
                    </p>
                    <!-- <span>Image ID: {{item.imageID}}</span> -->
                    <a>
                        <img *ngIf="item.imageID! > 0; else newImage" appSalesPlanImage
                            [salesPlanId]="item.salesPlanID!" [imageId]="item.imageID!" [fileIndex]="13"
                            class="img-fluid m-auto d-block" style="margin-bottom:25px !important;pointer-events:auto;"
                            onError="this.src='assets/images/loader_btn.gif'" />
                        <ng-template #newImage>
                            <img src="data:{{item.type}};base64,{{item.base64Bytes}}" class="img-fluid m-auto d-block" style="margin-bottom:25px !important;pointer-events:auto;"
                                onError="this.src='assets/images/loader_btn.gif'" />
                        </ng-template>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
</fieldset>

<p-confirmDialog position="top" [baseZIndex]="200000" appendTo="body" role="alertdialog"></p-confirmDialog>